var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('h1',{staticClass:"loader__title"},[_vm._v("Pomóż wilkom :)")]),_c('div')])}]

export { render, staticRenderFns }